import { createFileRoute } from '@tanstack/react-router';
import RequestsView from '../jobs/view/requests/RequestsView';

export const Route = createFileRoute('/orders/$orderGuid_/jobs/$jobGuid/requests')({
  component: RequestsView,
});
